import { useEffect } from 'react';

import { axiosClient } from '../../shared/api/utils/provider';
import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getCsrf } from '../api/services/Auth';

export const useCsrfQuery = () => {
  const { data } = useApiGet<{ authenticityToken: string }>(['authenticityToken'], getCsrf, {
    enabled: true,
  });

  useEffect(() => {
    const requestInterceptor = axiosClient.interceptors.request.use((req) => {
      if (req.method !== 'get') {
        req.headers['X-CSRF-TOKEN'] = data?.authenticityToken;
      }

      return req;
    });

    // To avoid the infinity loop if the latter also receives the response code 401, we eject the interceptor in this case
    return () => {
      axiosClient.interceptors.request.eject(requestInterceptor);
    };
  }, [data?.authenticityToken]);
};
